import axios from "axios";
import React, { useEffect, useState } from "react";
import ContentLoader from "react-content-loader";
import { Link, useParams } from "react-router-dom";
import helpers from "../helper";
// import Meta from "./layout/Meta";
import { Helmet } from "react-helmet";

export default function Category() {
  let params = useParams();
  const [pageloader, setPageloader] = useState(false);
  const [pagedata, setPagedata] = useState();
  const [products, setProducts] = useState([]);

  useEffect(() => {
    setPageloader(true);
    async function fetchData() {
      await axios
        .get(process.env.REACT_APP_API + "api/categories/" + params.alias)
        .then((response) => {
          setPagedata(response.data.result);
          setProducts(response.data.result?.products);
          setPageloader(false);
        });
    }
    fetchData();
  }, [params]);

  return (
    <>
      <Helmet>
        <title>
          {pagedata
            ? pagedata.meta_title
            : "This product is not available yet."}
        </title>
        <meta
          name="description"
          content={pagedata ? pagedata.meta_description : ""}
        />
        <meta
          name="keywords"
          content={pagedata ? pagedata.meta_keywords : ""}
        />
      </Helmet>
      <main>
        <section className="InnerHead bgthm2">
          <img
            loading="lazy"
            src={require("../assets/img/img-bg.svg").default}
            alt="Product"
            className="imgbg"
            width="1600"
            height="453"
          />
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-8 text-center">
                <h1 className="fw-normal text-white">
                  {pagedata?.name ?? "Our Category"}
                </h1>
                <ol className="breadcrumb m-0 justify-content-center">
                  <li className="breadcrumb-item">
                    <Link to="/">
                      <img
                        src={require("../assets/img/home.svg").default}
                        width="14"
                        height="14"
                        alt="Home"
                      />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="/categories">Categories</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <span aria-current="page">
                      {pagedata?.name ?? "Our Category"}
                    </span>
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </section>
        <section className="Sec2 ProSec">
          {pageloader ? (
            <div className="container">
              <ContentLoader height={900} width={1200}>
                <rect x="30" y="20" rx="8" ry="8" width="200" height="200" />
                <rect x="30" y="250" rx="0" ry="0" width="200" height="18" />
                <rect x="30" y="275" rx="0" ry="0" width="120" height="20" />
                <rect x="250" y="20" rx="8" ry="8" width="200" height="200" />
                <rect x="250" y="250" rx="0" ry="0" width="200" height="18" />
                <rect x="250" y="275" rx="0" ry="0" width="120" height="20" />
                <rect x="470" y="20" rx="8" ry="8" width="200" height="200" />
                <rect x="470" y="250" rx="0" ry="0" width="200" height="18" />
                <rect x="470" y="275" rx="0" ry="0" width="120" height="20" />
                <rect x="690" y="20" rx="8" ry="8" width="200" height="200" />
                <rect x="690" y="250" rx="0" ry="0" width="200" height="18" />
                <rect x="690" y="275" rx="0" ry="0" width="120" height="20" />
                <rect x="910" y="20" rx="8" ry="8" width="200" height="200" />
                <rect x="910" y="250" rx="0" ry="0" width="200" height="18" />
                <rect x="910" y="275" rx="0" ry="0" width="120" height="20" />
                <rect x="1130" y="20" rx="8" ry="8" width="200" height="200" />
                <rect x="1130" y="250" rx="0" ry="0" width="200" height="18" />
                <rect x="1130" y="275" rx="0" ry="0" width="120" height="20" />
                <rect x="30" y="340" rx="8" ry="8" width="200" height="200" />
                <rect x="30" y="570" rx="0" ry="0" width="200" height="18" />
                <rect x="30" y="595" rx="0" ry="0" width="120" height="20" />
                <rect x="250" y="340" rx="8" ry="8" width="200" height="200" />
                <rect x="250" y="570" rx="0" ry="0" width="200" height="18" />
                <rect x="250" y="595" rx="0" ry="0" width="120" height="20" />
              </ContentLoader>
            </div>
          ) : (
            <div className="container">
              {pagedata && (
                <div className="row justify-content-center">
                  <div className="col-12 col-lg-8 text-center">
                    {/* <h2 className="Heading">{pagedata.name}</h2> */}
                    <div className="col-12 CmsPage">
                      {pagedata.short_description}
                    </div>
                  </div>
                </div>
              )}

              {products.length > 0 ? (
                <div className="row mt-3 justify-content-center">
                  {products.map((product, p) => (
                    <div key={p} className="col-lg-3 col-md-4 col-sm-6">
                      <Link
                        to={"/product/" + product.alias}
                        className="card ProBlock CarBlock"
                      >
                        <div className="card-header">
                          {helpers.helpers1(product.image) ? (
                            <picture className="img">
                              <img
                                loading="lazy"
                                src={
                                  process.env.REACT_APP_IMAGE +
                                  "uploads/product/" +
                                  product.image
                                }
                                alt={product.title}
                                width="121"
                                height="131"
                              />
                            </picture>
                          ) : (
                            <picture className="img">
                              <source
                                srcSet={
                                  process.env.REACT_APP_IMAGE +
                                  "uploads/product/webp/" +
                                  product.image +
                                  ".webp"
                                }
                                type="image/webp"
                              />
                              <source
                                srcSet={
                                  process.env.REACT_APP_IMAGE +
                                  "uploads/product/avif/" +
                                  product.image +
                                  ".avif"
                                }
                                type="image/avif"
                              />
                              <img
                                loading="lazy"
                                src={
                                  process.env.REACT_APP_IMAGE +
                                  "uploads/product/jpg/" +
                                  product.image +
                                  ".jpg"
                                }
                                alt={product.title}
                                width="121"
                                height="131"
                              />
                            </picture>
                          )}
                        </div>
                        <div className="card-body text-center">
                          <h3>{product.title}</h3>
                          <span className="p-2 rounded-circle">
                            <img
                              src={require("../assets/img/arrow1.svg").default}
                              height="18"
                              width="18"
                              alt="Product Name"
                            />
                          </span>
                        </div>
                      </Link>
                    </div>
                  ))}
                </div>
              ) : (
                ""
              )}
              {pagedata && (
                <div
                  className="col-12 CmsPage"
                  dangerouslySetInnerHTML={{
                    __html: pagedata.description ?? "",
                  }}
                />
              )}
            </div>
          )}
        </section>
      </main>
    </>
  );
}
